import { ReactNode, createContext, useEffect, useState } from 'react';
import { getLanguage, setLanguage } from 'helpers/i18n';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import 'moment/locale/es';

export interface ILanguageContext {
  onLanguageChange: (data: string) => void;
  lang: string;
}
export const LanguageContext = createContext<ILanguageContext>({
  lang: 'es',
  onLanguageChange: () => {},
});

const LanguageContextProvider: React.FC<{ children: ReactNode }> = ({ children }) => {
  const { i18n } = useTranslation();
  const [lang, setLang] = useState<string>(getLanguage());

  useEffect(() => {
    moment.locale(lang);
  }, [lang]);

  const onLanguageChange = (selectedlang: string) => {
    i18n.changeLanguage(selectedlang);
    setLanguage(selectedlang);
    setLang(selectedlang);
  };
  return (
    <LanguageContext.Provider value={{ lang, onLanguageChange }}>
      {children}
    </LanguageContext.Provider>
  );
};
export default LanguageContextProvider;
